import React, { useState } from 'react'
import styled from 'styled-components'

const Portfolio = () => {
  const [web , setweb]=useState(true)
  const [UIUX , setUIUX]=useState(false)

  const webBtn=()=>{
    setweb(true)
    setUIUX(false)
  }

  const uiBtn=()=>{
    setweb(false)
    setUIUX(true)
  }
  return (
    <>
      <Wrapper>
        <div className="container">
           <div className="heading">
            <h1>Portfolio</h1>
           </div>


           {/* button  */}
            <div className="btns">
            <button  onClick={webBtn}>Web Development</button>
            <button  onClick={uiBtn}>UI / UX Designing</button>
            </div>

           {/* web Development  */}


            {
            web?<div className="webDevelopment">
            <div className="projects">
              <div className="box">
                <a href="https://e-commerce-site-p.netlify.app/" target='blank'>
                <img src="/Images/Ecommerce.png" alt="" />
                {/* <div className="details">
                  <h1>Visit Website</h1>
                </div> */}
                </a>
               
              </div>

              
              <div className="box">
                <a href="https://movie-bazaar.netlify.app/" target='blank'>
                <img src="/Images/movieWebsite.png" alt="" />
                {/* <div className="details">
                  <h1>Web Development</h1>
                </div> */}
                </a>
               
              </div>


              <div className="box">
                <a href="https://ntflix-clone.netlify.app/" target='blank'>
                <img src="/Images/clone.png" alt="Netflix Clone" />
                {/* <div className="details">
                  <h1>Web Development</h1>
                </div> */}
                </a>
               
              </div>
            
            
            </div>
            <div className="projects">
            <div className="box">
                <a href="https://h00bankkk.netlify.app/" target='blank'>
                <img src="/Images/bankApp.png" alt="" />
                {/* <div className="details">
                  <h1>Web Development</h1>
                </div> */}
                </a>
               
              </div>


              <div className="box">
                <a href="https://bootstrap-landiing-page.netlify.app/" target='blank'>
                <img src="/Images/bootstrap.png" alt="" />
                {/* <div className="details">
                  <h1>Web Development</h1>
                </div> */}
                </a>
               
              </div>


              <div className="box">
                <a href="https://firstproj-eab3b.web.app/" target='blank'>
                <img src="./Images/resumeBuilder.png" alt="" />
                {/* <div className="details">
                  <h1>Web Development</h1>
                </div> */}
                </a>
               
              </div>
            
            
            </div>
            </div>:""
            }
          
          {
            
            UIUX? <div className="UIUXdesigning">
             <div className="figmaLink">
              <a href="https://www.figma.com/file/pTCY1EnKVpbj1jEKhtXoUk/Projects?type=design&node-id=0%3A1&mode=design&t=gXcZJU4auyvwX1wc-1" target='blank'>Click here to go to Figma File</a>
             </div>
             <div className="behanceLink">
              <a href="https://www.behance.net/xpertdesigner787" target='blank'>Behance portfolio</a>
             </div>
            <div className="projects">
              <div className="box">
                <a href="https://www.behance.net/gallery/178588603/Law-Firm-Landing-Page"  target="blank">
                <img src="/Images/lawyer.png" alt="" />
                {/* <div className="details">
                  <h1>UI UX</h1>
                </div> */}
                </a>
               
              </div>

              
              <div className="box">
                <a href="https://www.behance.net/gallery/178556865/Investment-Website-Landing-Page" target='blank'>
                <img src="/Images/advance.png" alt="" />
                {/* <div className="details">
                  <h1>UI UX</h1>
                </div> */}
                </a>
               
              </div>
 

              <div className="box">
                <a href="https://www.behance.net/gallery/177552053/Find-Engineers-landing-page" target='blank'>
                <img src="/Images/engineer.png" alt="" />
                {/* <div className="details">
                  <h1>UI UX</h1>
                </div> */}
                </a>
               
              </div>
            
            
            </div>
            <div className="projects">
            <div className="box">
                <a href="https://www.behance.net/gallery/178558213/GPT-3-Landing-page" target='blank'>
                <img src="/Images/gpt.png" alt="" />
                {/* <div className="details">
                  <h1>UI UX</h1>
                </div> */}
                </a>
               
              </div>


              <div className="box">
                <a href="https://www.behance.net/gallery/150405559/CARS-COLLECTION" target='blank'>
                <img src="/Images/cars.png" alt="" />
                {/* <div className="details">
                  <h1>UI UX</h1>
                </div> */}
                </a>
               
              </div>


              <div className="box">
                <a href="https://www.behance.net/gallery/149110443/Eagle-eye" target='blank'>
                <img src="/Images/dashboard.png" alt="" />
                {/* <div className="details">
                  <h1>UI UX</h1>
                </div> */}
                </a>
               
              </div>
            
            
            </div>
            </div>:""
          }
          
        </div>
        <div className="line"></div>
      </Wrapper>
    </>
  )
}

export default Portfolio

const Wrapper = styled.section`
.container{
    width: 100%;
    height: auto;
    background-color: rgba(45, 46, 46, 1);
    padding-left: 5%;
    padding-right: 5%;
}
.heading{
  padding-top: 50px;
}
.heading h1{
  text-align: center;
  font-size: 35px;
  color: rgba(255, 204, 0, 1);
}
.btns{
  text-align: center;
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 50px;
}
.btns button{
  color: rgba(255, 204, 0, 1);
  border: 2px solid rgba(255, 204, 0, 1);
  padding: 10px 20px;
  border-radius: 65px;
  transition: 0.8s;
  background: none;
  cursor: pointer;
}
.btns button:hover{
  background-color: rgba(255, 204, 0, 1);
  color: white;
}
.webDevelopment{
  padding: 60px 0;
}
.UIUXdesigning{
  padding: 60px 0;
}
.projects{
  /* width: 100%; */
 display: flex;
 align-items: center;
 justify-content: space-around;
 flex-direction: row;
 /* margin-top: 30px; */
 


}
.box{
  position: relative;
  margin-bottom: 10px;
}
.box img{
  width: 28vw;
    height: 260px;
    border-radius: 10px;
    transition: 0.5s;
}
.box img:hover{
 transform: scale(1.05);
}
.details{
  width: 100%;
  height: 0%;
  border-radius: 10px;
  background-color: rgba(255, 204, 0, 0.5);
  position: absolute;
  bottom: 0;
overflow: hidden;
  transition: 0.5s;
}
.box:hover .details{
  height: 100%;
}
.line{
  width: 100%;
  height: 1px;
  background-color:  rgba(67, 67, 67, 1);
}
.figmaLink{
  padding: 0px 0 10px 0;
  text-align: center;
}
.figmaLink a{
  color:  rgba(255, 204, 0, 1);
}
.behanceLink{
  padding: 0px 0 30px 0;
  text-align: center;
}
.behanceLink a{
  color:  rgba(255, 204, 0, 1);
}


@media (max-width:768px) {
  .projects{
 display: flex;
 flex-direction: column;
}
.box img{
  width: 70vw;
}
.heading h1{
  font-size: 25px;
}
.btns button{
  font-size: 16px;
}
}
@media (max-width:576px) {

.box img{
  width: 90vw;
}
.btns button{
  font-size: 14px;
  padding: 10px 15px;
}
.btns{
  display: flex;
  gap: 10px;
}
}

`
